import Button from "../../../Components/Button";

const CompanyDetails = ({ Click, data, setData }) => {
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <div className="Company_Detail_Wrap">
      <h3>Company Details</h3>
      <div className="Box">
        <label htmlFor="company_name">Name of Company</label>
        <input
          type="text"
          id="company_name"
          name="company_name"
          value={data.company_name}
          onChange={handleChange}
        />
      </div>
      <div className="Box">
        <label htmlFor="company_location">
          Company Location (Please enter full Address of company){" "}
        </label>
        <input
          type="text"
          id="company_location"
          name="company_location"
          value={data.company_location}
          onChange={handleChange}
        />
      </div>
      <div className="Box">
        <label htmlFor="company_email">Email address</label>
        <input
          type="email"
          id="company_email"
          name="company_email"
          value={data?.company_email}
          onChange={handleChange}
        />
      </div>
      {/* <Button Click={Click} name="Next" /> */}
    </div>
  );
};

export default CompanyDetails;
